export default "__VITE_PUBLIC_ASSET__56976d80__"